import { Button } from "risa-oasis-ui_v2";

interface HeaderProps {
  onAddClick?: () => void;
}

const Header = ({ onAddClick }: HeaderProps) => {
  return (
    <div className="nar-configuration-layout__header flex w-full items-center justify-between">
      <div className="font-bold">Email Password Configuration</div>
      <div>
        <Button
          disabled={false}
          onClick={() => onAddClick?.()}
          buttonType="primary"
          size="medium"
        >
          Add Email and Password
        </Button>
      </div>
    </div>
  );
};

export default Header;
